// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` textarea{ overflow-x: hidden }

 /* Delete icon cell spanning two rows: center vertically and align to the right */
 .detail-row-delete {
   vertical-align: middle !important;
   text-align: right;
   width: 40px;
 }

 /* Description row spacing: restore comfortable separation from main row */
 .detail-desc-row td {
   padding-top: 1px; /* was 2px */
   padding-bottom: 9px; /* was 2px */
 }

 /* Main detail row padding: restore previous default for better visual grouping */
 tr.visible-hover > td {
   padding-top: 10px; /* was 6px */
   padding-bottom: 8px; /* was 4px */
 }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
